export const API_BASE_URL = '/back';
export const APP_TITLE_PREFIX = 'De Sangosse SAV';
